import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";
import { ChannelAddress, EdgeConfig, Utils } from "src/app/shared/shared";

@Component({
    selector: "oe-common-production-modal",
    templateUrl: "./modal.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ModalComponent extends AbstractModal {
    // reference to the Utils method to access via html
    public readonly isLastElement = Utils.isLastElement;
    public readonly CONVERT_TO_WATT = Utils.CONVERT_TO_WATT;
    public readonly CONVERT_TO_KILO_WATTHOURS = Utils.CONVERT_TO_KILO_WATTHOURS;

    public productionMeters: EdgeConfig.Component[] = [];
    public chargerComponents: EdgeConfig.Component[] = [];
    public isAsymmetric: boolean = false;

    /** Ertrag heute in Wh, pro Erzeugungs-Zähler-ID. Ersetzt die L1/L2/L3-Phasenanzeige,
     *  die für dieses Widget nicht zielführend ist (siehe Nutzer-Feedback). */
    public todayYieldWhByMeterId: { [componentId: string]: number | null } = {};
    public totalTodayYieldWh: number | null = null;

    protected override getChannelAddresses() {
        const channelAddresses: ChannelAddress[] = [];

        // Get Chargers
        this.chargerComponents = this.config
            .getComponentsImplementingNature("io.openems.edge.ess.dccharger.api.EssDcCharger")
            .filter((component) => component.isEnabled);

        // Get productionMeters
        this.config
            .getComponentsImplementingNature("io.openems.edge.meter.api.ElectricityMeter")
            .filter((component) => component.isEnabled && this.config.isProducer(component))
            .forEach((component) => {
                channelAddresses.push(new ChannelAddress(component.id, "ActivePower"));
                this.productionMeters.push(component);
            });

        return channelAddresses;
    }

    protected override onIsInitialized(): void {
        this.loadTodayYield();
    }

    /**
     * Lädt den heutigen Ertrag (kWh) je Erzeugungs-Zähler über dieselbe
     * queryHistoricTimeseriesEnergy-Anfrage, die auch die Historie-Seite nutzt.
     */
    private loadTodayYield(): void {
        if (this.productionMeters.length === 0) {
            return;
        }
        const energyChannels = this.productionMeters
            .map(meter => new ChannelAddress(meter.id, "ActiveProductionEnergy"));

        const today = new Date();
        this.service.queryEnergy(today, today, energyChannels).then(response => {
            let total = 0;
            let hasAnyValue = false;
            for (const meter of this.productionMeters) {
                const wh = response.result.data[new ChannelAddress(meter.id, "ActiveProductionEnergy").toString()];
                this.todayYieldWhByMeterId[meter.id] = wh;
                if (wh != null) {
                    total += wh;
                    hasAnyValue = true;
                }
            }
            this.totalTodayYieldWh = hasAnyValue ? total : null;
        });
    }
}
